import React, { useState, useContext, useEffect, useRef } from "react";

import { AppContext } from "../Provider/Provider";

import Medidor from './Medidor/MedidorComponent';
import BarraConsumo from './BarraConsumoComponent';
import ConsejosCard from './ConsejosCardComponent';


const Resultados = ({ onClick }) => {

  
  const [valoresConsumoState, setValoresConsumoState] = useContext(AppContext);
  
  const [arrayCategorias] = useState(valoresConsumoState.ValoresCategoriaCard);
  
  const scrollable = useRef();

  /** Para mostrar los nombres de las categorias en las barras de porcentaje */
  var cat = [];
  var mayor= 0;
  var mayorCat = "";

  /** 
   * Inicialización de Valores (Residencial) 
   * Actualizado al 04/08/2022
  */
  var cantidadkWh = 600; /** Para el precio de los primeros kWh y el excedente */
  var cuotaFijaPorSuministro = 1021.70; 
  var primeroskWh = 10.14147; // kwh * primeroskWh
  var excedentekWh = 12.40287; // kwh * cuotaFijaPorSuministro
  var importeTotalSinImpuestos = 0; // cuotaFijaPorSuministro + primeroskWh + excedentekWh
  var alumbradoPublico = 698.83;
  var importeTotalEnConceptoDeGarantia = 0; //importeTotalSinImpuestos + alumbradoPublico
  var IVA = 0.21;
  var IVAConsumidorFinal = 0; //importeTotalSinImpuestos * IVA
  var totalAPagarEstimadoBimestral = 0; // importeTotalEnConceptoDeGarantia + IVAConsumidorFinal


  if (arrayCategorias !== undefined) {
    cat = Object.keys(arrayCategorias);
  }  

  for (const consumo in arrayCategorias) {
    if(Math.trunc(
          (arrayCategorias[consumo].kWh/valoresConsumoState.TotalkWhBim)*100
        ) > mayor){
          mayor = (arrayCategorias[consumo].kWh/valoresConsumoState.TotalkWhBim)*100;
          mayorCat = consumo;
    }
  }

  if (valoresConsumoState.TotalkWhBim > cantidadkWh) {

    let tempImporte1 = cantidadkWh * primeroskWh;

    let tempImporte2 = Math.abs(valoresConsumoState.TotalkWhBim - cantidadkWh) * excedentekWh;

    importeTotalSinImpuestos = cuotaFijaPorSuministro + tempImporte1 + tempImporte2;
  } else {
    let tempImporte1 = valoresConsumoState.TotalkWhBim * primeroskWh;

    importeTotalSinImpuestos = cuotaFijaPorSuministro + tempImporte1;
  }

  importeTotalEnConceptoDeGarantia = importeTotalSinImpuestos + alumbradoPublico;

  IVAConsumidorFinal = importeTotalSinImpuestos * IVA;

  totalAPagarEstimadoBimestral = importeTotalEnConceptoDeGarantia + IVAConsumidorFinal;


  let localObj = valoresConsumoState;
    
  localObj.TotalImporteBim = Math.trunc(totalAPagarEstimadoBimestral * 100) / 100;
  setValoresConsumoState(localObj);


  function handleClick(event) {
    onClick(event.target.verResultados);
  }

  function prepareData(){
    
    var ValorEstimadoBimestral = valoresConsumoState.TotalImporteBim; 
    var ConsumoEstimadoBimestral = valoresConsumoState.TotalkWhBim; 
    var tempJSon = valoresConsumoState.tablasPorCategoria;
    var ItemsJSon = {};
    var ItemsHuman = "";
    var CantidadItems = 0;

     
    for (let i in tempJSon){
      CantidadItems += tempJSon[i].length;
     
      if(tempJSon[i].length > 0){
        ItemsJSon[i] = tempJSon[i];
      }
    }

    for (let i in ItemsJSon){
      ItemsHuman = ItemsHuman.concat(i, ": \n")
      for (let j in ItemsJSon[i]){
        /** Items en texto plano */
        ItemsHuman = ItemsHuman.concat("Cantidad: ", ItemsJSon[i][j].cantidad, ", ");
        ItemsHuman = ItemsHuman.concat("Consumo Bimestral: ", ItemsJSon[i][j].consumoBimestral, ", ");
        ItemsHuman = ItemsHuman.concat("Electrodomestico: ", ItemsJSon[i][j].electrodomestico, ", ");
        ItemsHuman = ItemsHuman.concat("kWh: ", ItemsJSon[i][j].kWh, ", ");
        ItemsHuman = ItemsHuman.concat("Uso Diario: ", ItemsJSon[i][j].usoDiario, ". \n");
      }
    }

    ItemsJSon = JSON.stringify(ItemsJSon);

    return {
      ValorEstimadoBimestral,
      ConsumoEstimadoBimestral,
      ItemsJSon,
      ItemsHuman,
      CantidadItems
    };
  }

  /**
   * Se deja sin uso por el momento
   */
  function handleClose() {

    var currentUrl = window.location.href; // URL Actual
    var fatherUrl = document.referrer; // Url de quien llama a Censo de Carga
    
    if(fatherUrl != "" && currentUrl != "" &&
      (fatherUrl.toLowerCase() == process.env.REACT_APP_FATHER_URL && currentUrl == process.env.REACT_APP_CURRENT_URL)
      ){ 

      var dataCenso = prepareData();
      
          try {
              window.opener.datosCensoCargaFather(dataCenso);
          } catch (err) {
            console.error(err);
          }   
    }
    window.close();     
  }

  const scrollToElement = () => scrollable.current.scrollIntoView();
  
  useEffect(() => {
    scrollToElement();
     
  },[]);

  return (
      <div ref={scrollable} className="grid grid-cols-1 md:grid-cols-2 | m-2 md:mx-8 md:my-4 | text-sm text-black font-medium">
        <div className={""}>
          <div className={"grid grid-cols-6 md:grid-cols-12"}>
            <div className={"col-start-1"}>
              <span
                className={
                  "rounded-full px-4 mr-2 bg-dpecGreen text-white p-1 leading-none items-center"
                }
              >
                3
              </span>
            </div>
            <p className={" col-start-2 col-span-4 md:col-span-8"}>
              El resumen de tu simulación es el siguiente:
            </p>
          </div>
          <div
            id={"mensual-estimado"}
            className={"grid grid-cols-3 md:grid-cols-4 gap-y-8 | my-4"}
          >
            {/* Mantener comentado hasta que requieran lo contrario */}
            {/* <p className={"col-start-1 | text-xl font-extrabold"}>
              IMPORTE BIMESTRAL ESTIMADO:
            </p>
            <div className={"col-start-2 | text-4xl | text-green-700 | mt-10"}>
              ${totalAPagarEstimadoBimestral.toFixed(2)}
            </div> */}
            <p className={"col-start-1 | text-lg font-extrabold"}>
              CONSUMO BIMESTRAL ESTIMADO:
            </p>
            <div className={"col-start-2 col-span-2 | mt-10 ml-2 md:ml-0"}>
              <div className={"text-4xl | text-green-700"}>
                {valoresConsumoState.TotalkWhBim} kWh
              </div>
              <br />
            </div>
          </div>
          <div className={"grid grid-cols-1 content-center"}>
            <Medidor />
          </div>
          <p
            className={
              "font-bold md:font-semibold text-green-700 md:text-black | my-4"
            }
          >
            Tu consumo se encuentra distribuido de la siguiente forma:
          </p>
          <div className={"grid grid-cols-1 md:grid-cols-2 gap-x-8"}>
            {cat.map((cate, index) => (
              <div key={index}>
                <BarraConsumo name={cate}/>
              </div>
            ))}
          </div>
        </div>
        <div className={"relative | mb-20 md:mb-0"}>
          <h1 className={"my-4 md:mt-0 | text-xl font-bold text-green-700"}>
            CONSEJOS PARA MEJORAR TU CONSUMO
          </h1>
          <div className={"mb-12"}>
            <ConsejosCard mostrarConsejos={mayorCat}/>
          </div>
          <div className={"w-full text-center space-x-4 absolute bottom-0"}>
            <button
              type={"button"}
              className={"inline-flex justify-center px-4 py-1 text-xs font-small text-white bg-green-700 border border-transparent rounded-md hover:bg-green-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-black-500 | disabled:opacity-40 disabled:cursor-default | shadow-md"}
              onClick={handleClick}
            >
            VOLVER
            </button>
            {/* Mantener comentado hasta que requieran lo contrario */}
            <button
              type={"button"}
              className={"inline-flex justify-center px-4 py-1 text-xs font-small text-white bg-green-700 border border-transparent rounded-md hover:bg-green-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-black-500 | disabled:opacity-40 disabled:cursor-default | shadow-md"}
              onClick={handleClose}
            >
              {(window.location.href == process.env.REACT_APP_CURRENT_URL) ? 'CERRAR Y ENVIAR' : 'CERRAR'}
            </button>
          </div>
        </div>
      </div>
  );
}

export default Resultados
